/**
 * Add a class when the element is inside the viewport
 *
 * @param  {Element} el Trigger element
 * @param  {Object} props Class to add
 */
export default function inViewport(el, { delay, visibleClass }) {
  const addVisibleClass = () => el.classList.add(visibleClass);

  if (!window.IntersectionObserver) {
    addVisibleClass();
    return;
  }

  const observer = new IntersectionObserver(handleIntersect, { root: null });
  observer.observe(el);

  function handleIntersect(entries) {
    const entry = entries[0];
    if (entry && entry.isIntersecting) {
      observer.disconnect();
      setTimeout(addVisibleClass, delay || 0);
    }
  }

  return {
    destroy() {
      observer.disconnect();
    }
  };
}
